import { FilterValueListService, FilterValue } from '../filter/types';
import { Injectable } from '@angular/core';
import { RewardType } from '@app/core/types/reward';
import { RewardTypeTranslationPipe } from '@app/shared/pipes/reward-type-translation.pipe';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class RewardTypeValueListService implements FilterValueListService {
  private rewardTypeTranslationPipe = new RewardTypeTranslationPipe();

  constructor(private translate: TranslateService) {}

  getFilterValues$(): FilterValue[] {
    return Object.values(RewardType).map(value => {
      return {
        value: value,
        displayText: this.translate.instant(this.rewardTypeTranslationPipe.transform(value))
      };
    });
  }
}